/* eslint-disable react/jsx-key */
import clsx from 'clsx';

import styles from '../../styles.module.scss';
import { listMobile as unknownBrowserListMobile } from '../../Unknown/content';
import ImageDesktop1 from '../images/firefox-desktop-1.png';
import ImageDesktop2 from '../images/firefox-desktop-2.png';

export const listDesktop = [
    <div className={clsx(styles.contentDesktop, styles.center)}>
        Нажмите на&nbsp;значок c&nbsp;замком&nbsp;
        <img src={ImageDesktop1} alt='' />
        &nbsp;в&nbsp;адресной строке
    </div>,
    <>В&nbsp;появившемся окне перейдите в&nbsp;раздел &laquo;Защищённое соединение&raquo;</>,
    <>Нажмите на&nbsp;пункт &laquo;Подробнее&raquo; внизу списка и&nbsp;перейдите на&nbsp;вкладку &laquo;Разрешения&raquo;</>,
    <div className={clsx(styles.contentDesktop, styles.column)}>
        Разрешите доступ для микрофона&nbsp;/ камеры
        <img className={styles.image} src={ImageDesktop2} alt='' />
    </div>,
];

export const listMobile = unknownBrowserListMobile;
